var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconHearth = function SvgIconHearth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.22 6c-.864 0-1.674.334-2.28.941a3.242 3.242 0 0 0 0 4.573L12 18.585l7.06-7.071a3.24 3.24 0 0 0 0-4.573c-1.212-1.215-3.348-1.213-4.56 0l-1.792 1.795a1.028 1.028 0 0 1-1.416 0L9.5 6.94A3.2 3.2 0 0 0 7.22 6M12 21a.994.994 0 0 1-.707-.294l-7.768-7.78a5.245 5.245 0 0 1 0-7.399C4.509 4.543 5.82 4 7.22 4s2.712.543 3.695 1.527L12 6.614l1.085-1.086A5.185 5.185 0 0 1 16.78 4a5.19 5.19 0 0 1 3.694 1.527 5.243 5.243 0 0 1 0 7.399l-7.767 7.781a1 1 0 0 1-.708.293",
    fill: "#FA5851",
    fillRule: "evenodd"
  })));
};

export default SvgIconHearth;